import { render, staticRenderFns } from "./CRadio.vue?vue&type=template&id=45480634&scoped=true&"
import script from "./CRadio.vue?vue&type=script&lang=ts&"
export * from "./CRadio.vue?vue&type=script&lang=ts&"
import style0 from "./CRadio.vue?vue&type=style&index=0&id=45480634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45480634",
  null
  
)

export default component.exports